import {Language} from './language'

/**
 * The default language for the application.
 */
export const globalDefaultLanguage = new Language('en', 'US', 'English', 'American English')
